export default [
	{
		path: '/bot/:botId/sub-bot-list',
		name: 'SubBotList',
		component: require('../pages/subBots/subBots.list.vue').default,
		meta: {
			navigationSubTitle: 'subBots'
		}
    },
	{
		path: '/bot/:botId/sub-bot/:subBotId',
		name: 'SubBotDetail',
		component: require('../pages/subBots/subBots.detail.vue').default,
		meta: {
			navigationSubTitle: 'subBots'
		}
	}
]


// WEBPACK FOOTER //
// ./src/router/subBots.js